import { Component, inject, OnInit } from '@angular/core';
import { AdminBoilerplateComponent } from "../../../core/admin-boilerplate/feature/admin-boilerplate.component";
import { Store } from '@ngrx/store';

import { AsyncPipe } from '@angular/common';
import { selectAllAdminOrganisers } from '../../../data-services/stores/selectors/admin.selectors';
import { adminActions } from '../../../data-services/stores/actions/admin.actions';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-admin-organisers',
  imports: [AdminBoilerplateComponent, AsyncPipe,RouterModule],
  templateUrl: '../ui/organisers.component.html',
  styleUrl: '../ui/organisers.component.css',
})
export class AdminOrganisersComponent implements OnInit {
  private readonly _store = inject(Store);
  userOrganisers$ = this._store.select(selectAllAdminOrganisers)

  ngOnInit(): void {
    this._store.dispatch(adminActions.getOrganisers());
  }
}
